const API_BASE = import.meta.env.VITE_API_BASE ?? '';

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code?: string,
    public details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

function getToken(): string | null {
  return localStorage.getItem('sa_access_token');
}

export function setTokens(access: string, refresh: string) {
  localStorage.setItem('sa_access_token', access);
  localStorage.setItem('sa_refresh_token', refresh);
}

export function clearTokens() {
  localStorage.removeItem('sa_access_token');
  localStorage.removeItem('sa_refresh_token');
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  const token = getToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);

  const res = await fetch(`${API_BASE}${path}`, { ...init, headers });
  const data = (await res.json().catch(() => ({}))) as {
    error?: { message?: string; code?: string; details?: unknown };
  };

  if (!res.ok) {
    throw new ApiError(
      data.error?.message ?? 'Request failed',
      res.status,
      data.error?.code,
      data.error?.details,
    );
  }
  return data as T;
}
